import { ROUTES } from 'routes'

/**
 * The main nav's title + route, top to bottom — nothing else.
 *
 * The SINGLE source for "the sidebar's own order" (VRG-227): `Sidebar.tsx`'s `MAIN_MENU`
 * maps over this to attach icons and the Home progress badge, and the docs index
 * (`docs/categoryOrder.ts`) imports it directly to order its categories the way the
 * sidebar already does — without pulling in the sidebar's icon set or its checklist hook,
 * and without a second hand-typed copy of the title order that could drift out of sync
 * with the real rail.
 *
 * Reorder the sidebar by reordering THIS array. `MAIN_MENU` and the docs index both
 * follow it by construction.
 */
export const MAIN_NAV_ORDER: { title: string; link: string }[] = [
  { title: 'Home', link: ROUTES.HOME },
  { title: 'Analytics', link: ROUTES.ANALYTICS },
  { title: 'Tags', link: ROUTES.TAGS },
  { title: 'Products', link: ROUTES.PRODUCTS },
  { title: 'Certificates', link: ROUTES.CERTIFICATES },
  // VRG-455 — sales recorded against a buyer with no certificate named yet. Its own
  // entry rather than a Certificates tab: the whole point is that a record of this kind
  // has NO certificate to sit under until the buyer scans, and it is an object the brand
  // creates, searches and voids (§8). Placed after Certificates because that is the
  // object it resolves into.
  { title: 'Sales', link: ROUTES.SALES },
  { title: 'People', link: ROUTES.OWNERS },
  { title: 'Studio', link: ROUTES.STUDIO },
]
